import React, { useEffect, useContext } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom'
import MainAuth from './routes/auth/SignIn.js';
import MainApp from './routes/application/index.js';
import { NotificationContainer } from 'react-notifications';
import ForgotPassword from './routes/auth/ForgotPassword';
import 'react-notifications/lib/notifications.css';

import AuthProvider, { AuthIsSignedIn, AuthIsNotSignedIn } from './contexts/authContext';
import AppAuthContext from './contexts/AppAuthContext.tsx';

import Home from './routes/application/home/Home';
import LoginCallback from './routes/auth/LoginCallback';

const App = () => {
	
	return (
		<div className="app-main">
			<NotificationContainer/>
			<AuthProvider>	
				<AuthIsSignedIn>
					<AppAuthContext>
						<BrowserRouter>
							<Routes>
								<Route path='/*' element={<MainApp/>}/>
							</Routes>
						</BrowserRouter>
					</AppAuthContext>
				</AuthIsSignedIn>
				<AuthIsNotSignedIn>
					<BrowserRouter>
						<Routes>
							<Route path='/login-callback' element={<LoginCallback/>}></Route>
							{/* <Route path='/forgot-password' element={<ForgotPassword/>}/> */}
							<Route path='/*' element={<MainAuth/>}/>
						</Routes>
					</BrowserRouter>
				</AuthIsNotSignedIn>
			</AuthProvider>
		</div>
	);
}

export default App;
